import React, {Component} from "react";
import {InputNumber, Checkbox, Radio} from "antd";
import { injectIntl } from "react-intl";
import {isEqual} from "lodash-es";
import {TertiaryButton} from "../../../Common/button";
import AcknowledgementLayout from "../../../../Containers/BindingPharmacy/acknowledgement";
import UploadAttachments from "../../../../Containers/AdminConsole/common/uploadAttachment";
import CloseIcon from "../../../../Assets/images/close.svg";
import messages from "./messages";
import "./style.less";

class EditQuota extends Component{
    constructor(props){
	super(props);
	this.state={
	    scheduleOneDoc:"",
	    scheduleTwoDoc:"",
	    narcoticsDoc:"",
	    setCirculationTwo:false,
	    setCirculationOne: false,
	    setNarcotics:false,
	    scheduleOneQuotaAmount:0,
	    scheduleTwoQuotaAmount:0
	};
    }
    
    formatMessage = data => this.props.intl.formatMessage(data);
    

    uploadHandler = (data, type) => {
	if(type==="scheduleOneDoc"){
	    this.setState({
		scheduleOneDoc: data
	    });
	}
	else if(type==="scheduleTwoDoc"){
	    this.setState({
		 scheduleTwoDoc: data
	     });
	}
	else if(type==="narcotics"){
	    this.setState({
		narcoticsDoc: data
	    });
	}
    };


    deleteUpload = (type) => {
	if(type==="scheduleOneDoc"){
	    this.setState({
		scheduleOneDoc: ""
	    });
	}
	else if(type==="scheduleTwoDoc"){
	    this.setState({
		scheduleTwoDoc: ""
	    });
	}
	else if(type==="narcotics"){
	    this.setState({
		narcoticsDoc: ""
	    });
	}
    };
    
    
    

    componentDidUpdate(prevProps, prevState) {
	const {data:{dispensationQuotaDetails:prevDispensationQuotaDetails={}}={}, show:prevShow} = prevProps;
	const {data:{dispensationQuotaDetails={}, user_role=""}={}, show} = this.props;
	if(!isEqual(prevDispensationQuotaDetails, dispensationQuotaDetails)){
	    let quotasState = {};
	    for(const key in dispensationQuotaDetails){
		const {quotas={}, validity_date_from="", validity_date_to="", products={}} = dispensationQuotaDetails[key];
		if(key==="Shedule 1 - Circulation"){
		    this.setState({scheduleOne_validity_date_from: validity_date_from, scheduleOne_validity_date_to:validity_date_to});
		}
		else if(key==="Shedule 2 - Circulation"){
		    this.setState({scheduleTwo_validity_date_from: validity_date_from, scheduleTwo_validity_date_to:validity_date_to});
		}
		for(const quotaKey in quotas){
		    if(key==="Shedule 1 - Circulation"){
			const {amount=""} = quotas[quotaKey];
			const quotaId = `scheduleOne_` + quotaKey;
			quotasState[quotaId] = parseInt(amount);
		    }
		    else if(key==="Shedule 2 - Circulation"){
			const {amount=""} = quotas[quotaKey];
			const quotaId = `scheduleTwo_` + quotaKey;
			quotasState[quotaId] = parseInt(amount);
		    }
		}

		if(key==="Schedule 1 - Narcotics" && user_role==="Super Admin"){
		    let approvedValues = {};
		    let disabled;
		    for(const prodId in products){
			const {approved_amount} = products[prodId];
			if(approved_amount===null || approved_amount===0 || approved_amount === undefined){
			    disabled=true;
			}
			approvedValues[`productId_`+prodId] = approved_amount===null?0:approved_amount;
		    }
		    
		    this.setState({approvedValues, disabled});
		}
	    }

	    this.setState({quotasState});
	}

	if(!isEqual(prevShow, show) && prevShow===true && show === false){
	    this.setState({setCirculationTwo:false, setCirculationOne:false, setNarcotics:false});
	}
    }



    submitQuota = async() => {
	const {data:{bindingFormId, editQuota, user_role="", onSuccess}={}, close} = this.props;
	const {quotasState, setCirculationTwo, setCirculationOne, scheduleOneDoc, scheduleTwoDoc, setNarcotics, narcoticsDoc, scheduleOne, scheduleTwo, scheduleOneQuotaAmount, scheduleTwoQuotaAmount} = this.state;

	let data = {};
	if(setCirculationOne){
	    data["schedule1_circulation_trading_regulation_id"] = 2;
	    if(scheduleOne==="0"){
		data["schedule1_circulation_dispensation_quota"] = scheduleOneQuotaAmount; 
	    }
	    else{
		data["schedule1_circulation_dispensation_quota"] = scheduleOne;
	    }
	    data["schedule1CirculationQuotaChangeReasonDocument"] = {};
	    data["schedule1CirculationQuotaChangeReasonDocument"]["originalname"] = scheduleOneDoc[0].originalname;
	    data["schedule1CirculationQuotaChangeReasonDocument"]["file_path"] = scheduleOneDoc[0].file_path;
	}
	if(setCirculationTwo){
	    data["schedule2_circulation_trading_regulation_id"] = 1;
	    if(scheduleTwo==="0"){
		data["schedule2_circulation_dispensation_quota"] = scheduleTwoQuotaAmount; 
	    }
	    else{
		data["schedule2_circulation_dispensation_quota"] = scheduleTwo; 
	    }
	    data["schedule2CirculationQuotaChangeReasonDocument"] = {};
	    data["schedule2CirculationQuotaChangeReasonDocument"]["file_path"] = scheduleTwoDoc[0].file_path;
	    data["schedule2CirculationQuotaChangeReasonDocument"]["originalname"] = scheduleTwoDoc[0].originalname;

	}

	if(setNarcotics){
	    data["schedule1_narcotic_trading_regulation_id"] = 3;
	    data["schedule1NarcoticQuotaChangeReasonDocument"]= {};
	    data["schedule1NarcoticQuotaChangeReasonDocument"]["file_path"] = narcoticsDoc[0].file_path;
	    data["schedule1NarcoticQuotaChangeReasonDocument"]["originalname"] = narcoticsDoc[0].originalname;

	    data["schedule1_narcotic_products"] = [];

	    console.log(this.state.approvedValues);
	    
	    for(const prodId in this.state.approvedValues){
		const productId = prodId.split("_")[1];
		const prodObj = {};
		prodObj.id = productId;
		prodObj.approved_amount = this.state.approvedValues[prodId];
		data["schedule1_narcotic_products"].push(prodObj);
	    }
	}

	//if(user_role==="Eda Inspector"){
	data["pharmacyId"] =  bindingFormId;
	data["is_schedule1_narcotic_dispensation_permission"] = setNarcotics;
	//}
	// else{
	//     data["bindingFormId"] =  bindingFormId;
	// }
	data["is_schedule1_circulation_dispensation_permission"] =  setCirculationOne;
	data["is_schedule2_circulation_dispensation_permission"] =  setCirculationTwo;
	
	const response = await editQuota(data);
	const {status} = response;
	if(status){
	    onSuccess();
	    close();
	}
	
    };
    


    onChangeApprovedAmount = (e, uniqueId) => {
	let disabled;
	const val = e;
	const approvedValuesCopy = {...this.state.approvedValues};
	approvedValuesCopy[uniqueId] = val;
	for(const prodId in approvedValuesCopy){
	    const amount = approvedValuesCopy[prodId];
	    if(amount === null || amount === 0 || amount === undefined){
		disabled = true;
	    }
	}
	this.setState({approvedValues: approvedValuesCopy, disabled});
    };
    

    onChangeQuota = (e, id) => {
	if(id==="scheduleOne"){
	    this.setState({
		scheduleOne: e.target.value
	    });
	}
	else if(id==="scheduleTwo"){
	    this.setState({
		scheduleTwo: e.target.value
	    });
	}
    };


    onChangeQuotaAmount = (e, id) => {
	if(id==="scheduleOne"){
	    this.setState({
		scheduleOneQuotaAmount: e
	    });
	}
	else if(id==="scheduleTwo"){
	    this.setState({
		scheduleTwoQuotaAmount: e
	    });
	}
    }


    setShowCirculationOne = (e) => {
	this.setState({
	    setCirculationOne:e.target.checked
	});
    };

    setShowCirculationTwo = (e) => {
	this.setState({
	    setCirculationTwo:e.target.checked
	});
    };

    setShowNarcotics = (e) => {
	this.setState({
	    setNarcotics: e.target.checked
	});
    };


    onChangeNarcoticsAttachment = (e) => {
	this.setState({
	    showNarcoticsAttachment:e.target.value
	});
    }
    
    
    
    showQuotas = (id) => {
	const {onChangeQuota, onChangeQuotaAmount, formatMessage} = this;
	const quotasUI = [];
	const value = this.state[id];
	const quotaAmount = this.state[`${id}QuotaAmount`];
	quotasUI.push(
		<div className="flex align-items-center mt10" style={{marginLeft:"38%"}} className="edit-quota" key={id}>
		<Radio.Group onChange={(e)=>onChangeQuota(e, id)} defaultValue={value}>
		<Radio value={"1"} className="mt10"><span className="bold">{formatMessage(messages.one)}</span></Radio>
		<Radio value={"3"} className="mt10"><span className="bold">{formatMessage(messages.two)}</span></Radio>
		<Radio value={"0"} className="mt10"><span className="bold">{formatMessage(messages.specialCase)}</span></Radio>
		</Radio.Group>
		{value==="0"?<InputNumber className={`w20 mt20 h45`} min={0} onChange={(e) => onChangeQuotaAmount(e, id)} defaultValue={quotaAmount}/>:null}
	    {value==="0"?<span className="fs18 bold ml10 mr10">{formatMessage(messages.xQuota)}</span>:null}
	    </div>
	);
	

	return quotasUI;
    };


    getProductUI = (products) => {
	const productUI = [];
	const {onChangeApprovedAmount} = this;

	const {approvedValues={}} = this.state;
	
	for(const prodId in products){
	    const {product_id, requested_amount, approved_amount, trade_name:tradeName="", id} = products[prodId];
	    const uniqueId = `productId_` + id;
	    // const value = approvedValues[uniqueId] || 0;
	    productUI.push(
		    <div className="flex align-items-center" key={product_id}>
		    <span className="fs16 w25">{product_id}</span>
		    <span className="fs16 w25">{tradeName}</span>
		    <span className="fs16 w25">{requested_amount}</span>
		    <InputNumber
		className={`w20 mt20`}
		defaultValue={approved_amount}
		onChange={(e) => onChangeApprovedAmount(e, uniqueId)}
		    />
		    </div>
	    );
	}

	return <div className="mt20">{productUI}</div>;
    };



    showNarcoticsProducts = (products) => {
	const {getProductUI} = this;
	return (<div className="member-border p20 mt20 mlrauto">
		<div className="flex">
		<span className="bold fs16 w25">{this.formatMessage(messages.prodNum)}</span>
		<span className="bold fs16 w25">{this.formatMessage(messages.prodTradeNum)}</span>
		<span className="bold fs16 w25">{this.formatMessage(messages.reqAmount)}</span>
		<span className="bold fs16 w25">{this.formatMessage(messages.amountApp)}</span>
		</div>
		{getProductUI(products)}
		</div>);
    };
    
    
    
    
    showCirculationOne = (quotas) => {
	const {uploadHandler, deleteUpload, setShowCirculationOne} = this;
	const {setCirculationOne} = this.state;
	return (
		<div>
		<div className="flex justify-content-center align-items-center mt10">
		<Checkbox onChange={setShowCirculationOne}/>
		<span className="ml10 mr10 bold fs16">{this.formatMessage(messages.circulationOne)}</span>
		</div>

	    {setCirculationOne?<div>
		{this.showQuotas("scheduleOne")}
		<div className="flex justify-content-center">
	     <UploadAttachments placeHolder={this.formatMessage(messages.reasonDoc)} width={"w50"} uploadHandler={uploadHandler} deleteUpload={deleteUpload} fieldType={"scheduleOneDoc"} type={"async"}/>
		</div>
	     </div>:null}

	    </div>
	);
    };

    showCirculationTwo = (quotas) => {
	const {uploadHandler, deleteUpload, setShowCirculationTwo} = this;
	const {setCirculationTwo} = this.state;
	return (
		<div>
		<div className="flex justify-content-center align-items-center">
		<Checkbox onChange={setShowCirculationTwo}/>
		<span className="ml10 mr10 bold fs16">{this.formatMessage(messages.circulationTwo)}</span>
		</div>

	    {setCirculationTwo?<div>
		{this.showQuotas("scheduleTwo")}
		<div className="flex justify-content-center">
	     <UploadAttachments placeHolder={this.formatMessage(messages.reasonDoc)} width={"w50"} uploadHandler={uploadHandler} deleteUpload={deleteUpload} fieldType={"scheduleTwoDoc"} type={"async"}/>
		</div>
	     </div>:null}
		
		</div>
	);
    };

    showNarcotics = (products) => {
	const {uploadHandler, deleteUpload, setShowNarcotics, showNarcoticsProducts} = this;
	const { setNarcotics} = this.state;
	return (
		<div>
		<div className="flex justify-content-center align-items-center">
		<Checkbox onChange={setShowNarcotics}/>
		<span className="ml10 mr10 bold fs16">{this.formatMessage(messages.narcotics)}</span>
		</div>

	    {setNarcotics?<div>
	     <div className="flex justify-content-center">
	     <UploadAttachments placeHolder={this.formatMessage(messages.reasonDoc)} width={"w50"} uploadHandler={uploadHandler} deleteUpload={deleteUpload} fieldType={"narcotics"} type={"async"}/>
	     </div>

	     {showNarcoticsProducts(products)}
	     
	     </div>:null}
		
		</div>
	);
    };
    
    showEditQuotaUI = () => {
	
	const editQuotaUI = [];
	const {scheduleOneDoc, scheduleTwoDoc, setCirculationOne, setCirculationTwo, setNarcotics, narcoticsDoc} = this.state;
	const {showCirculationOne, showCirculationTwo, showNarcotics, submitQuota} = this;
	const {data:{dispensationQuotaDetails={}, user_role={}}={}, close} = this.props;

	let disabled;
	if(user_role==="Super Admin"){
	    disabled = (setCirculationOne && scheduleOneDoc==="") || (setCirculationTwo && scheduleTwoDoc==="") || (setNarcotics && narcoticsDoc==="") || (!setCirculationTwo && !setCirculationOne && !setNarcotics );
	}
	else{
	    disabled = (setCirculationOne && scheduleOneDoc==="") || (setCirculationTwo && scheduleTwoDoc==="") || (!setCirculationTwo && !setCirculationOne);
	}
	
	
	for(const key in dispensationQuotaDetails){
	    const {trading_regulation_id="3", quotas={}, products={}} = dispensationQuotaDetails[key];
	    if(trading_regulation_id==="2"){
		editQuotaUI.push(
			<div key={trading_regulation_id}>
			{showCirculationOne(quotas)}
		    </div>
		);
	    }
	    else if(trading_regulation_id==="1"){
		editQuotaUI.push(
			<div key={trading_regulation_id} className="mt30">
			{showCirculationTwo(quotas)}
		    </div>
		);
	    }
	    else if(trading_regulation_id==="3" && user_role==="Super Admin"){
		editQuotaUI.push(
			<div key={trading_regulation_id} className="mt30">
			{Object.keys(products).length ? showNarcotics(products) : null}
		    </div>
		);
	    }
	}
	
	return (
	    <div>
		<div className="flex justify-content-end  mt30 mr40 ml40 clickable" onClick={close}>
		<img src={CloseIcon} alt="close modal" className="mt20"/>
		</div>
		<div className="flex justify-content-center align-items-center mt10 medium fontsize22 mandatory">
		{this.formatMessage(messages.editQuota)}
	    </div>
		{editQuotaUI}
	    <div className="flex justify-content-center align-items-center mt30 mb30">
		<TertiaryButton
	    text={this.formatMessage(messages.submit)}
            width="wpx120"
	    handleOnClick={submitQuota}
	    disabled={disabled}
		/>
		</div>
		</div>
	);
    };
    

    render() {
	const {show} = this.props;
	if(!show){
	    return null;
	}
	
	return (
		<AcknowledgementLayout>
		{this.showEditQuotaUI()}
		</AcknowledgementLayout>
	);
    };
};


export default injectIntl(EditQuota);
